export default "__VITE_ASSET__CDSVnrj4__";